import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

const isAdultsValid = (adults: unknown): boolean => {
  const parsedAdults = Number(adults)
  return Number.isInteger(parsedAdults)
}

export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  if (query.adults && !isAdultsValid(query.adults)) {
    const redirectQuery = {
      ...query,
      adults: undefined,
    }
    return navigateTo(
      {
        path,
        query: redirectQuery,
        hash: hash ?? undefined,
      },
      { redirectCode: 301 },
    )
  }
})
